<template>
  <editor
    v-if="instance"
    v-model="instance"
    @cancel="cancel()"
    @saved="saved($event)"
  />
</template>
<script>
import editor from "vue-template/protected/editors/SettingsEditor";
import LoadPageMixin from "vue-template/protected/mixins/LoadPageMixin";
import { LoggedUserService } from "vue-template";

export default {
  mixins: [ LoadPageMixin ],

  components: {
    editor
  },

  props: {
    defaultRoute: {
      type: [String, Object],
      default: '/'
    }
  },

  methods: {
    breadcrumbs() {
      return [
        {
          icon: 'home',
          text: 'Home',
          to: '/protected'
        },
        {
          text: () => this.$t("menu.settings"),
          //text: () => this.$t('settings.tabs.main'),
        }
      ]
    },

    async load() {
      try {
        console.log('loading settings');
        this.instance = await LoggedUserService.getSettings();
        this.$emit("breadcrumbs", this.breadcrumbs());
      } catch (e) {
        this.handleLoadError(e);
      }
    },

    cancel() {
      this.$router.push(this.defaultRoute);
    },

    saved() {
      this.$router.push(this.defaultRoute);
    }
  }
};
</script>
